// 多选部门dlg组件

const branchDlgMul = {
  namespaced: true,

  state: {
    dlgShow: false,

    permission: true,

    branchIds: '',

    branchNames: '',

    branchType: 0,
  },

  getters: {
    dlgShow: state => state.dlgShow,

    permission: state => state.permission,

    branchIds: state => state.branchIds,

    branchNames: state => state.branchNames,

    branchType: state => state.branchType
  },

  mutations: {
    SET_DLGSHOW: (state, val) => {
      state.dlgShow = val
    },

    SET_PERMISSION: (state, val) => {
      state.permission = val
    },

    SET_BRANCHIDS: (state, val) => {
      state.branchIds = val
    },

    SET_BRANCHNAMES: (state, val) => {
      state.branchNames = val
    },

    SET_BRANCHTYPE: (state, val) => {
      state.branchType = val
    }
  },

  actions: {

  }
}

export default branchDlgMul
